import { useState } from 'react'
import { User, LogOut, ChevronRight } from 'lucide-react'
import KioskNumpad from './KioskNumpad'

type Props = {
  machine: { codigo: string; nome: string; tipo: string; localizacao: string | null }
  onLogin: (pin: string) => void
  onUnpair: () => void
}

export default function KioskLogin({ machine, onLogin, onUnpair }: Props) {
  const [pin, setPin] = useState('')

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-violet-50 to-blue-50">
      <header className="px-6 py-4 flex items-center justify-between bg-white border-b border-ink-200">
        <div>
          <div className="text-xs text-ink-500 uppercase">Máquina</div>
          <div className="font-bold text-ink-900">{machine.codigo} — {machine.nome}</div>
        </div>
        <button
          onClick={onUnpair}
          className="text-xs text-ink-500 hover:text-red-600 flex items-center gap-1"
        >
          <LogOut className="h-3 w-3" /> Desparear
        </button>
      </header>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-6 space-y-6">
          <div className="text-center space-y-2">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-violet-100 text-violet-600">
              <User className="h-8 w-8" />
            </div>
            <h1 className="text-xl font-bold text-ink-900">Identificação do operador</h1>
            <p className="text-sm text-ink-500">Digite seu PIN</p>
          </div>

          <div className="bg-ink-50 rounded-xl p-4 text-center">
            <div className="text-3xl font-mono font-bold tracking-widest h-12 flex items-center justify-center">
              {pin ? '•'.repeat(pin.length) : <span className="text-ink-300">_ _ _ _</span>}
            </div>
          </div>

          <KioskNumpad value={pin} onChange={setPin} maxLen={8} />

          <button
            onClick={() => pin && onLogin(pin)}
            disabled={!pin || pin.length < 3}
            className="w-full h-14 bg-violet-600 hover:bg-violet-700 active:bg-violet-800 text-white font-semibold rounded-xl flex items-center justify-center gap-2 disabled:opacity-40 transition"
          >
            Entrar <ChevronRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  )
}
